import PlntFcmp from './PlntFcmp'
import * as firebaseConfig from './NotificationInitializeClientFcm.json'

//const PublicVapidKey = "BHayIV2WR9S4H4vjI78uhgJnlFV5vWfchOSo2k4vxJxk3MNcBj2uz89-rk3kVfTs0GHT8T7TCgo_GYc5Vl_h11k";

export const AskPushSubscription = (allowed, del, setAlertMessage, setAlertActive) => {
    // Si controlla se il client ha la possibilit� di usufruire del navigator (se � un apple con safari si fermer� qui)
    if (navigator !== undefined && navigator !== null && navigator.permissions !== undefined && navigator.permissions !== null) {
        PlntFcmp.log('AskPushSubscription()', allowed, del);
        PlntFcmp.init(firebaseConfig.default, setAlertMessage, setAlertActive); //PublicVapidKey, 
        if (Notification.permission === 'default' /*window.localStorage.getItem('stopRequestPushNotification') === '0' || window.localStorage.getItem('stopRequestPushNotification') === null ||*/) {
            PlntFcmp.log('ask');
            if (Notification.permission === 'granted') {
                PlntFcmp.deleteToken();
            }
            AcceptPush()
        }
    } else {
        PlntFcmp.log('Init not possible, client can\'t provide this functionality.');
    }
    /*switch (allowed) {
        case 'blocked':
            {
                PlntFcmp.log('blocked');
                if (Notification.permission === 'granted') {
                    PlntFcmp.revokeToken();
                }
                break;
            }
        case 'allowed':
            {
                PlntFcmp.log('allowed');
                window.localStorage.setItem('stopRequestPushNotification', 1);
                if (del) {
                    PlntFcmp.deleteToken(function () {
                        PlntFcmp.initToken();
                    });
                } else {
                    PlntFcmp.initToken();
                }

                break;
            }
        case 'ask':
            {
                if (window.localStorage.getItem('stopRequestPushNotification') === '0' || window.localStorage.getItem('stopRequestPushNotification') === null || Notification.permission === 'default') {
                    PlntFcmp.log('ask');
                    if (Notification.permission === 'granted') {
                        PlntFcmp.deleteToken();
                    }
                    //overlayPushMessageShow();
                }
                break;
            }
    }*/
};

export const AcceptPush = () => {
    if (Notification.permission === 'denied') {
        alert("You have blocked the push notifications from Unicef PWA.\nPlease enable it if you want receive the push notifications change the configuration of your browser");
    } else {
        PlntFcmp.initToken();
        /*window.localStorage.setItem('stopRequestPushNotification', 1);
        //overlayPushMessageHide();

        if (Notification.permission === 'granted') {
            window.location.reload();
        }*/
    }
}

export const NotAcceptPush = () => {
    window.localStorage.setItem('stopRequestPushNotification', 1);
    PlntFcmp.setMacAddress(null, function () {
        PlntFcmp.sendRevokeSubscriptionToBackEnd();
    });
    //overlayPushMessageHide();
}

if (navigator !== undefined && navigator !== null && navigator.permissions !== undefined && navigator.permissions !== null) {
    navigator.permissions.query({ name: 'notifications' }).then(function (permission) {
        permission.onchange = function () {
            if (window.localStorage.getItem('lastNotificationPermission') === 'denied' && Notification.permission === 'granted') {
                //overlayPushMessageShow();
            }
            window.localStorage.setItem('lastNotificationPermission', Notification.permission);
        };
    })
}

export default AskPushSubscription